import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import FieldsSection from '../../../../../../features/components/Form/FieldsSection'
import ControllerMemberContentReusableFields from '../../../ControllerInviteCreate/ControllerInviteCreateForm/ControllerInviteCreateFormContent/ControllerMemberContentReusableFields'

import { BUYER } from '../../../../../../constants/permissions'
import { BRAND_CATEGORY } from '../../../fields'

const ControllerMemberEditFormContent = ({ formik, memberRole }) => {
  const { values } = formik

  const isBrandCategoryRequired = useMemo(() => {
    return memberRole === BUYER
  }, [memberRole])

  return (
    <FieldsSection title="Controller member">
      <ControllerMemberContentReusableFields
        formik={formik}
        controllerMemberRole={memberRole}
        showClearBrandCategory={values[BRAND_CATEGORY] && !isBrandCategoryRequired}
      />
    </FieldsSection>
  )
}

ControllerMemberEditFormContent.propTypes = {
  formik: PropTypes.object.isRequired,
  memberRole: PropTypes.string.isRequired
}

export default ControllerMemberEditFormContent
